import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Cercles décoratifs rappelant le logo Qolaig, posés sur le bandeau bleu nuit. */
function HeroRings({ className }: { className?: string }) {
  return (
    <svg
      width="520"
      height="340"
      viewBox="0 0 520 340"
      aria-hidden
      className={cn('pointer-events-none absolute', className)}
    >
      <circle cx="300" cy="160" r="150" fill="none" stroke="#1CB5C8" strokeOpacity="0.3" strokeWidth="2" />
      <circle cx="300" cy="160" r="100" fill="none" stroke="#1CB5C8" strokeOpacity="0.18" strokeWidth="2" />
      <circle cx="420" cy="240" r="72" fill="#1CB5C8" fillOpacity="0.1" />
      <circle cx="300" cy="160" r="7" fill="#1CB5C8" />
      <circle cx="328" cy="140" r="4" fill="#5FD3E3" />
      <circle cx="276" cy="137" r="4" fill="#5FD3E3" />
    </svg>
  )
}

interface HeroBannerProps {
  children: ReactNode
  /** Classes du conteneur interne (padding, layout) */
  className?: string
  ringsClassName?: string
}

/** Bandeau bleu nuit en tête de page (liste et fiche projet). */
export function HeroBanner({ children, className, ringsClassName }: HeroBannerProps) {
  return (
    <section className="relative overflow-hidden bg-brand-navy text-white">
      <HeroRings className={cn('-right-16 -top-10 hidden md:block', ringsClassName)} />
      <div className={cn('relative mx-auto w-full max-w-7xl px-4 sm:px-8', className)}>{children}</div>
    </section>
  )
}
